import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IncidentsStoreModule } from './store'

@NgModule({
  imports: [CommonModule, IncidentsStoreModule],
  exports: [IncidentsStoreModule],
})
export class IncidentLibraryModule {}
